import { searchContractors } from '~/api/v2';
import { useSearch } from '~/components/QuickNav/useSearch';

const RESULT_LIMIT = 5;

function search(query: string, signal?: AbortSignal) {
    return searchContractors({ query: { query, limit: RESULT_LIMIT }, signal });
}

export function useContractorSearch(query: string, enabled: boolean) {
    const { results, pending, failed } = useSearch(query, enabled, search);
    return { contractors: results, pending, failed };
}
